import React, { useEffect, useState } from 'react';
import { ExternalLink } from 'lucide-react';
import { portalApi } from '../../lib/portalApi';
import { PORTAL_AUDITS } from '../../constants/testIds';

const PortalAudits = () => {
  const [audits, setAudits] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    portalApi.get('/portal/audits').then(({ data }) => setAudits(data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid={PORTAL_AUDITS.page}>
      <h1 className="text-2xl font-extrabold text-stone-900 mb-1">My Heatmaps</h1>
      <p className="text-stone-500 text-sm mb-7">Your Google Maps ranking audits.</p>

      {!loading && audits.length === 0 ? (
        <div data-testid={PORTAL_AUDITS.emptyState} className="bg-white border border-dashed border-stone-300 rounded-2xl p-12 text-center">
          <p className="text-stone-500 text-sm">No heatmaps yet — your first audit will show up here once it's run.</p>
        </div>
      ) : (
        <div className="bg-white rounded-2xl border border-stone-200 overflow-hidden">
          <table data-testid={PORTAL_AUDITS.table} className="w-full text-sm">
            <thead className="bg-stone-50 text-stone-500 text-xs uppercase font-semibold">
              <tr>
                <th className="text-left px-5 py-3">Keyword</th>
                <th className="text-left px-5 py-3">SoLV</th>
                <th className="text-left px-5 py-3">Avg rank</th>
                <th className="text-left px-5 py-3">Report</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-stone-100">
              {audits.map((a) => (
                <tr key={a.id}>
                  <td className="px-5 py-4 font-semibold text-stone-900">{a.keyword}</td>
                  <td className="px-5 py-4 text-stone-600">{a.solv ? `${a.solv}%` : '—'}</td>
                  <td className="px-5 py-4 text-stone-600">{a.arp ?? '—'}</td>
                  <td className="px-5 py-4">
                    {a.public_url && (
                      <a href={a.public_url} target="_blank" rel="noreferrer" className="text-[#4F46E5] hover:underline inline-flex items-center gap-1">
                        View <ExternalLink size={12} />
                      </a>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default PortalAudits;
